import React, {  useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import useUserStore from '../stores/Users';
import Icon from './Icon';
import './Navbar.css';

import { baseAPI } from '../services/baseAPI';

function Navbar() {

  // Roles
  const ADMIN = 1;
  const ANGGOTA = 2;
  const USP = 3;
  const PEMBIAYAAN = 4;
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);
  const logout = useUserStore((state) => state.logout);

  const [isLoading, setIsLoading] = useState(false);
  const [dataNotif, setDataNotif] = useState();
  const [displayedItems, setDisplayedItems] = useState(3);
  const [totNotif, setTotNotif] = useState();
  const history = useHistory();

  // CONTROLLER
  const fetchDataNotif = async (userId) => {

    await baseAPI
      .get(`/v1/notification/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.notifAll.data
        const totIsRead = res.data.data.notifAll.totIsRead
        setDataNotif(data)
        setTotNotif(totIsRead);
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };


  useEffect(() => {
    setIsLoading(true);
    // if (users.role === ADMIN) {
      fetchDataNotif(user.id);
    // }
  }, [token, totNotif]);

  const Linked = ({ to, title, children }) => {
    const location = useLocation();
    const isActive = location.pathname === to; // Check if the current path matches the link's path

    return (
      <li
        className={
          isActive ? 'nav-item Navbar_item Navbar_active' : 'nav-item Navbar_item'
        }
      >
        <Link className="nav-link Navbar_nav-link" to={to}>
          <span className='nav-link-icon Navbar_icon d-md-none d-lg-inline-block'>{children}</span>
          <span className='Navbar_title'>{title}</span>
        </Link>
      </li>
    );
  };

  Linked.propTypes = {
    to: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
  };

  const Linked2 = ({ to, title }) => {
    const location = useLocation();
    const isActive = location.pathname.split('/')[2] === to.split('/')[2] && location.pathname.split('/')[1] == to.split('/')[1]; // Check if the current path matches the link's path

    return (
      <li
        className={
          isActive ? 'nav-item Navbar_item Navbar_active no-indent' : 'nav-item Navbar_item no-indent'
        }
      >
        <Link className="Navbar_nav-link" to={to} style={{padding: "10px"}}>
          <span className='Navbar_title' style={isActive ? {color: "#CD5C08"} : {color: "#656d77"}}>{title}</span>
        </Link>
      </li>
    );
  };

  Linked2.propTypes = {
    to: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout(null);
  };

  const MenuDropdown = ({ to, title, icon, children }) => {
    const location = useLocation();
    const isActive = location.pathname.split('/')[1] == to; // Check if any employee link is active

    return (
      <li className="nav-item dropdown">
          <a
            href="#user"
            className="nav-link Navbar_nav-link"
            data-bs-toggle="dropdown"
            aria-label="Open user menu"
          >
            <span className="nav-link-icon Navbar_icon d-md-none d-lg-inline-block">
              <Icon name={icon} size={17} style={isActive ? {color: "#CD5C08"} : {color: "#656d77"}} />
            </span>
            <span className="Navbar_title" style={isActive ? {color: "#CD5C08"} : {color: "#656d77"}}>{title}</span>
          </a>
        <div className="dropdown-menu text-start">
          {children}
        </div>
      </li>
    );
  };
  
  MenuDropdown.propTypes = {
    to: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
  };

  // masih blm rampung
  const handleItemClick = (id) => {
    if (id != "all") {
      // Handle item click, you can navigate to a new page or perform other actions
      history.push(`/broadcast/${id}`);
    } else {
      history.push(`/broadcastlist`);
    }
  };

  // VIEW
  return (
    <div className='sticky-top'>
      {/* header */}
      <header className="navbar navbar-expand-md navbar-dark Navbar_dark sticky-top d-print-none">
        <div className="container-fluid">
          {/* leftside */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar-menu"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={`${process.env.PUBLIC_URL}/static/logo_kopkar.png`}
              style={{ width: '42px', height: '42px', marginRight: '5px' }}
              alt="logo"
            />
            <h5 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3" style={{ fontSize: 20, color: "#CD5C08", margin: '0', marginLeft: '0' }}>
              Dashboard  Aerospace Bandung
            </h5>
          </div>

          {/* rightside */}
          <div className="navbar-nav flex-row order-md-last">
            {/* notifikasi */}
            <div className='nav-item Navbar_nav-item dropdown d-md-flex me-3'>
              <Link
                className='nav-link Navbar_nav-link px-0'
                data-bs-toggle='dropdown'
                tabindex='-1'
                aria-label='Show notifications'>
                <Icon name='Bell' size={17} color={"#fff"} />
                <span className={`${totNotif > 0 ? 'badge bg-red' : ''}`}></span>
              </Link>
              <div className='dropdown-menu dropdown-menu-arrow dropdown-menu-end dropdown-menu-card'>
                <div className='card' style={{width: "14rem"}}>
                  <div class="card-header">
                    <h3 class="card-title">Last updates</h3>
                  </div>
                  <div class="list-group list-group-flush list-group-hoverable">
                    {dataNotif &&
                      dataNotif.slice(0, displayedItems).map((e, index) => (
                      <div class="list-group-item" key={index} onClick={() => handleItemClick("all")}>
                        <div class="row align-items-center">
                          <div class="col-auto"><span className={`badge ${e.isRead == 1 ? 'bg-success' : 'bg-secondary'}`}></span></div>
                            <div class="col text-truncate">
                              <div class="alert-title d-block">
                                {e.title}
                              </div>
                              <div class="d-block text-secondary text-truncate mt-n1">
                                <p style={{marginBottom: 0}}>{moment(e.updated_at).format("DD/MM/yyyy HH:mm")}</p>
                                {e.body}
                              </div>
                            </div>
                          <div class="col-auto">
                            <a href="#" class="list-group-item-actions">
                              {/* <!-- Download SVG icon from http://tabler-icons.io/i/star --> */}
                              <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path></svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                    {dataNotif && dataNotif.length > displayedItems && (
                      <div class="list-group-item text-center">
                        <button className="btn btn-link" onClick={() => handleItemClick("all")}>
                          Show More
                        </button>
                      </div>
                    )}
                    {/* <div class="list-group-item">
                      <div class="row align-items-center">
                        <div class="col-auto"><span className='badge bg-red'></span></div>
                        <div class="col text-truncate">
                          <a href="#" class="text-body d-block">Example 2</a>
                          <div class="d-block text-secondary text-truncate mt-n1">
                            justify-content:between ⇒ justify-content:space-between (#29734)
                          </div>
                        </div>
                        <div class="col-auto">
                          <a href="#" class="list-group-item-actions show">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon text-yellow" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path></svg>
                          </a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            {/* profile */}
            <div className="nav-item Navbar_nav-item dropdown">
              <a
                href="#user"
                className="nav-link Navbar_nav-link d-flex lh-1 text-reset p-0"
                data-bs-toggle="dropdown"
                aria-label="Open user menu"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/static/avatar.jpg`}
                  className="avatar Navbar_avatar avatar-sm"
                  alt="users"
                />
                <div className="d-none d-xl-block ps-2">
                  <div className="username">
                    <strong>
                      {user.name}
                    </strong>
                  </div>
                  {/* <div className="mt-1 small">{user.email}</div> */}
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                {/* <Link to='/profile' className='dropdown-item'>Set status</Link>
                <Link to='/profile' className='dropdown-item'>Profile & account</Link>
                <Link to='/profile' className='dropdown-item'>Feedback</Link> */}
                {/* <Link to="/password" className="dropdown-item">
                  Ubah Password
                </Link> */}
                <a 
                  href="#handleLogout" 
                  onClick={(e) => handleLogout(e)} 
                  className="dropdown-item"
                >
                    Logout
                </a>
                <a 
                  href="/auth/profile" 
                  // onClick={(e) => handleLogout(e)} 
                  className="dropdown-item"
                >
                    Profile
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* menu */}
      <div className="navbar-expand-md">
        <div className="collapse navbar-collapse" id="navbar-menu">
          <div className="navbar navbar-light">
            <div className="container-fluid">
              <ul className="navbar-nav">

                {/* home */}
                <Linked to="/" title="Home">
                  <Icon name="Home" size={17} />
                </Linked>

                {user.role === ANGGOTA || user.role === PEMBIAYAAN || user.role === USP || user.role === BENDAHARA || user.role === ADMIN ?
                // {user.role === ANGGOTA ?
                <>
                  {/* tabungan */}
                  <MenuDropdown title="Tabungan" icon="Archive" to="tabungan">
                      <Linked2 to="/tabungan/pengajuan" title="Pengajuan Tabungan" />
                      <Linked2 to="/tabungan/mutasi" title="Mutasi" />
                      <Linked2 to="/tabungan/tabunganku" title="Tabunganku" />
                  </MenuDropdown>

                  {/* pinjaman */}
                  <MenuDropdown title="Pinjaman Tunai" icon="Database" to="tunai">
                      <Linked2 to="/tunai/pengajuanpinjam" title="Pengajuan Pinjaman Tunai" />
                      <Linked2 to="/tunai/mutasipinjaman" title="Mutasi Pinjaman Tunai" />
                      <Linked2 to="/tunai/statuspinjaman" title="Status Pinjaman Tunai" />
                      <Linked2 to="/tunai/pelunasanpinjaman" title="Pelunasan Pinjaman" />
                  </MenuDropdown>

                  {/* pinjaman barang */}
                  <MenuDropdown title="Pinjaman Barang" icon="Gift" to="barang">
                      <Linked2 to="/barang/pengajuanpinjambarang" title="Pengajuan Pinjaman Barang" />
                      <Linked2 to="/barang/mutasipinjamanbarang" title="Mutasi Pinjaman Barang" />
                      <Linked2 to="/barang/statusbelibarang" title="Status Pembelian Barang" />
                      <Linked2 to="/barang/pelunasanpinjamanbarang" title="Pelunasan Pinjaman Barang" />
                  </MenuDropdown>
                </>
                : <></>}

                {user.role === USP || user.role === BENDAHARA ?
                <>
                  {/* data pinjaman */}
                  <MenuDropdown title="Data Pinjaman Tunai" icon="Layers" to="pinjamtunai">
                      <Linked2 to="/pinjamtunai/listpengajuanpinjamtunai" title="List Pengajuan Pinjaman Tunai" />
                      <Linked2 to="/pinjamtunai/datapinjamantunai" title="Data Pinjaman Tunai" />
                      {user.role === USP ?
                        <Linked2 to="/pinjamtunai/listpelunasanpinjamtunai" title="List Pelunasan Pinjaman Tunai" />
                      : <></>}
                  </MenuDropdown>
                </>
                : <></>}

                {user.role === USP ?
                <>
                  {/* data tabungan */}
                  <MenuDropdown title="Data Tabungan" icon="Book" to="datatabungan">
                      <Linked2 to="/datatabungan/listtabungan" title="List Tabungan" />
                      <Linked2 to="/datatabungan/listpengajuantabungan" title="List Pengajuan Tabungan" />
                  </MenuDropdown>
                </>
                : <></>}

                {user.role === PEMBIAYAAN || user.role === BENDAHARA ?
                <>
                  {/* data pinjaman barang */}
                  <MenuDropdown title="Data Pinjaman Barang" icon="Layers" to="pinjambarang">
                      <Linked2 to="/pinjambarang/listpengajuanpinjambarang" title="List Pengajuan Pinjaman Barang" />
                      <Linked2 to="/pinjambarang/datapinjamanbarang" title="Data Pinjaman Barang" />
                      {user.role === PEMBIAYAAN ?
                        <Linked2 to="/pinjambarang/listpelunasanpinjambarang" title="List Pelunasan Pinjaman Barang" />
                      : <></>}
                  </MenuDropdown>
                </>
                : <></>
                }

                {user.role === BENDAHARA ?
                <>
                  {/* tagihan */}
                  <MenuDropdown title="Tagihan" icon="Clipboard" to="tagihan">
                      <Linked2 to="/tagihan/iuranwajib" title="Simpanan Wajib" />
                      <Linked2 to="/tagihan/iuranspn" title="Iuran SPN" />
                      <Linked2 to="/tagihan/tabungan" title="Tabungan" />
                      <Linked2 to="/tagihan/pinjamtunai" title="Pinjaman Tunai" />
                      <Linked2 to="/tagihan/pinjambarang" title="Pinjaman Barang" />
                      <Linked2 to="/tagihan/simpananpokok" title="Simpanan Pokok" />
                  </MenuDropdown>
                  
                  {/* kas */}
                  <MenuDropdown title="Kas" icon="Book" to="kas">
                      <Linked2 to="/kas/mutasikas" title="Mutasi Kas" />
                      <Linked2 to="/kas/addkas" title="Tambah Mutasi Kas" />
                      <Linked2 to="/kas/invoice" title="Cetak Invoice" />
                      {/* <Linked2 to="/kas/riwayatinvoice" title="Riwayat Invoice" /> */}
                  </MenuDropdown>
                </>
                : <></>
                }

                {user.role === ADMIN ?
                <>
                  {/* Anggota */}
                  <MenuDropdown title="Anggota" icon="User" to="anggota">
                      <Linked2 to="/anggota/tambahanggota" title="Tambah Anggota" />
                      <Linked2 to="/anggota/listanggota" title="List Anggota" />
                      {/* <Linked2 to="/anggota/resetpasswordanggota" title="Reset Password Anggota" /> */}
                  </MenuDropdown>

                  {/* Setting Koperasi */}
                  <MenuDropdown title="Setting" icon="Settings" to="setting">
                      <Linked2 to="/setting/identitaskoperasi" title="Identitas Koperasi" />
                      <Linked2 to="/setting/settingbiaya" title="Setting Biaya" />
                      <Linked2 to="/setting/settingdate" title="Setting Date" />
                  </MenuDropdown>

                </>
                : <></>}

                {user.role === ADMIN || user.role === USP || user.role === PEMBIAYAAN || user.role === BENDAHARA ?
                <>
                  {/* Broadcast info */}
                  <Linked to="/broadcast" title='Broadcast'>
                    <Icon name="Send" size={17} />
                  </Linked>
                </>
                : <></>
                }

              </ul>

              {/* search bar */}
              {/* <div className='my-2 my-md-0 flex-grow-1 flex-md-grow-0 order-first order-md-last'>
                <form action='.' method='get'>
                  <div className='input-icon'>
                    <span className='input-icon-addon'>
                      <Icon name='Search' size={17} />
                    </span>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Search…'
                      aria-label='Search in website'
                    />
                  </div>
                </form>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Navbar;
